import { render, staticRenderFns } from "./SmallBowel.vue?vue&type=template&id=ef02f1ba"
import script from "./SmallBowel.vue?vue&type=script&lang=ts"
export * from "./SmallBowel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports